import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { ApplicationConfig } from '../../config/config';
import { UrlUtil } from '../../config/urlutil';

@Injectable({
  providedIn: 'root'
})
export class TripService {
  private result: any;
  private todaysTripObservable: Observable<any>;
  todaysTripData = null;
  constructor(
    private _http: HttpClient,
    private config: ApplicationConfig,
    private urlUtil: UrlUtil,
    private loggingService: LoggingService
  ) {}

  public getTripDetailsDetails(skymilesNbr: string): Observable<any> {
    if (this.todaysTripData) {
      return of(this.todaysTripData);
    } else if (this.todaysTripObservable) {
      return this.todaysTripObservable;
    } else {
      this.todaysTripObservable = this.callTodaysTripService(skymilesNbr).pipe(
        map(
          (response) => {
            this.todaysTripObservable = null;
            if (response) {
              this.todaysTripData = response;
            } else {
              this.todaysTripData = null;
            }
            return this.todaysTripData;
          },
          (err) => {
            this.loggingService.log(
              'Caught Error in todays trip service call :: getTripDetailsDetails: ' +
                err
            );
          }
        ),
        share()
      );
      return this.todaysTripObservable;
    }
  }

  callTodaysTripService(skymilesNbr: string) {
    const nmbrOfTrips = '1';
    const requestOptions = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/x-www-form-urlencoded')
        .append('Accept', 'application/json'),
      params: new HttpParams()
    };

    // new HttpParams().append('skymilesNbr', skymilesNbr).append('nmbrOfTrips', nmbrOfTrips)
    return this._http.post(
      `${this.config.get('APP_TRIPS_TODAY_URL')}`,
      this.urlUtil.toObjQueryString({
        skymilesNbr: skymilesNbr,
        nmbrOfTrips: nmbrOfTrips
      }),
      requestOptions
    );
  }

  public getIROPErrorMessage(): Observable<any> {
    return this._http.get(`${this.config.get('APP_MESSAGES_ERROR_URL')}`).pipe(
      map((res) => {
        this.result = res;
        // this.result = JSON.parse(this.result._body);
        return this.result;
      }),
      share()
    );
  }

  getNoUpcomingTripContent() {
    let tripStub = {};
    tripStub = {
      bookFlightLink: 'Book a Flight',
      myTripsLink: 'Find My Trips'
    };
    return tripStub;
  }
}
